import { IServiceProvider } from '../../../../../configuration/modules/modules.types';
import { IViewNavigator } from './../../../../../configuration/ViewNavigator';
//import { IServiceProvider } from '@dirootie-core/core-types';
import { ActionHandler, IActionHandler } from './dispatcher.types';
import { Action,IAction } from '@dirootie-web/components-types';

export type HandlersCollection = {
  navigateTo: IActionHandler;
  navigateBack: IActionHandler;
};

export const handlersFactory = (
  serviceProvider: IServiceProvider
): [ActionHandler, Action[]][] => {
  const navigator = serviceProvider.resolve<IViewNavigator>('navigator');

  const navigateToHandler = (action: IAction) => {
    navigator.navigateToPath(action.payload.path, {
      relative: action.payload.relative,
    });
    return Promise.resolve({ isSuccess: true });
  };

  return [[navigateToHandler, ['navigate_to', 'navigate_back','back']]];
};
